var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.propDialogObject
        ? _c(
            "el-dialog",
            {
              staticClass: "login-force-out-dialog",
              attrs: {
                title: "温馨提示",
                visible: _vm.dialogVisible,
                width: "600px",
                "before-close": _vm.closeDialog
              },
              on: {
                "update:visible": function($event) {
                  _vm.dialogVisible = $event
                }
              }
            },
            [
              _c("div", { staticClass: "c-text-tips" }, [
                _vm._v(" 还有"),
                _vm.propDialogObject.item.studentCount > 0
                  ? _c("span", { staticClass: "c-text-number-red" }, [
                      _vm._v(_vm._s(_vm.propDialogObject.item.studentCount))
                    ])
                  : _vm._e(),
                _vm.propDialogObject.item.studentCount > 0
                  ? _c("span", [_vm._v("个学员")])
                  : _vm._e(),
                _vm._v("未签退，建议您【取消】签退"),
                _c("br"),
                _vm._v(" 若您【强制签退】将结束此次培训"),
                _c("span", { staticClass: "c-text-red" }, [
                  _vm._v("强制签退学员，导致培训学时无效")
                ]),
                _vm._v("，请谨慎操作！ ")
              ]),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    { attrs: { size: "medium" }, on: { click: _vm.loginOut } },
                    [_vm._v("强制签退")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "medium" },
                      on: { click: _vm.closeDialog }
                    },
                    [_vm._v("取消")]
                  )
                ],
                1
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }